import { accountTypes } from "./accountTypes";
import { accountApi } from "./accountApi";

const onChange = (field, value) => {
  return dispatch => {
    dispatch({
      type: accountTypes.ACCOUNT_LOGIN_ONCHANGE,
      payload: { prop: field, value: value },
    });
  };
};

const onForgotPassword = email => async dispatch => {
  let response = await accountApi.forgotPassword(email);
  return response;
};

const onResetPassword = payload => async dispatch => {
  let response = await accountApi.resetPassword(payload);
  return response;
};

const onTFACall = payload => async dispatch => {
  let response = await accountApi.twoFAverification(payload);
  return response;
};

const onSubmit =
  (email, password, key, iv, fcmValue, rememberMe, deviceKey) =>
  async dispatch => {
    let response = await accountApi.login(
      email,
      password,
      key,
      iv,
      fcmValue,
      rememberMe,
      deviceKey,
    );
    return response;
  };

const onAddUserSession = pageUrl => async dispatch => {
  let response = await accountApi.addUserSession(pageUrl);
  return response;
};
const onGetUserAccountInfo = () => async dispatch => {
  let response = await accountApi.getUserAccountInfo();
  return response;
};

const onUpdateUserAccountInfo = userDate => async dispatch => {
  let response = await accountApi.updateUserAccountInfo(userDate);
  return response;
};

const onGetAllCounts = date => async dispatch => {
  let response = await accountApi.getAllCounts(date);
  return response;
};

const onLoginWithToken = token => async dispatch => {
  let response = await accountApi.tokenLogin(token);
  return response;
};

const onGetNotification = usrId => async dispatch => {
  let response = await accountApi.getNotification(usrId);
  if (response?.success) {
    dispatch({
      type: accountTypes.ACCOUNT_LOGIN_ONCHANGE,
      payload: { prop: "notificationData", value: response?.data },
    });
  } else {
    dispatch({
      type: accountTypes.ACCOUNT_LOGIN_ONCHANGE,
      payload: { prop: "notificationData", value: [] },
    });
  }
  return response;
};
const onMarkNotificationRead = notiData => async dispatch => {
  let response = await accountApi.markReadNotification(notiData);
  return response;
};

const onMarkNotificationReadByRmId = notiData => async dispatch => {
  let response = await accountApi.markReadNotificationByRmId(notiData);
  return response;
};

export const accountActions = {
  onChange: onChange,
  onSubmit: onSubmit,
  onAddUserSession: onAddUserSession,
  onGetUserAccountInfo: onGetUserAccountInfo,
  onUpdateUserAccountInfo: onUpdateUserAccountInfo,
  onGetAllCounts: onGetAllCounts,
  onForgotPassword: onForgotPassword,
  onResetPassword: onResetPassword,
  onTFACall: onTFACall,
  onLoginWithToken: onLoginWithToken,
  onGetNotification: onGetNotification,
  onMarkNotificationRead: onMarkNotificationRead,
  onMarkNotificationReadByRmId: onMarkNotificationReadByRmId,
};
